import Siema from 'siema';
import '../util/lazyLoad';
import _obj from '../util/_obj';
import NavMobileACF from '../nav-mobile-acf';

export default {
  init() {
    // JavaScript to be fired on all pages
    // Initialize mobile navigation
    new NavMobileACF();
  },
  finalize() {
    let sliders = {};

    /**
     * Mobile Nav Toggle
     */
    const navToggle = document.querySelector('#nav-toggle')
    const mobileNav = document.querySelector('.nav-mobile')

    if (navToggle !== null && navToggle.length) {
      navToggle.addEventListener('click', () => event => {
        event.preventDefault()
        navToggle.classList.toggle('active');
        mobileNav.classList.toggle('active');
      })
    }

    /**
     * Sliders use Siema. See: https://pawelgrzybek.github.io/siema/
     */
    const imageGrids = document.querySelectorAll('.image-grid')
    if(imageGrids != undefined && imageGrids.length) {
      [].forEach.call(imageGrids, imageGrid => {
        const lightbox = imageGrid.querySelector('.image-grid__lightbox')
        const sliderContainer = lightbox.querySelector('.image-grid__slider-container')
        const prevButton = lightbox.querySelector('.image-grid__slide-prev')
        const nextButton = lightbox.querySelector('.image-grid__slide-next')
        sliders.iamge_grid = new Siema({
          selector: sliderContainer,
          loop: true,
        })

        prevButton.addEventListener('click', () => sliders.iamge_grid.prev())
        nextButton.addEventListener('click', () => sliders.iamge_grid.next())

        lightbox.querySelector('.lightbox-close-button').addEventListener('click', event => {
          event.preventDefault()
          if(lightbox.classList.contains('visible')) {
            lightbox.classList.remove('visible')
            document.body.style.overflow = 'initial'
          }
        })

        const images = imageGrid.querySelectorAll('.image-grid-item')
        if(images != undefined && images.length) {
          [].forEach.call(images, image => {
            const index = image.dataset.index;
            image.addEventListener('click', event => {
              event.preventDefault();
              lightbox.classList.add('visible')
              sliders.iamge_grid.resizeHandler()
              sliders.iamge_grid.goTo(index)
              document.body.style.overflow = 'hidden'
            })
          })
        }
      });
    }
    /**
     * Hero Slider - Featured Hero Slides
     * Sliders use Siema. See: https://pawelgrzybek.github.io/siema/
     */
    const heroWrappers = document.querySelectorAll('.th_gr_hero-wrapper')

    if(heroWrappers != undefined && heroWrappers.length) {
      [].forEach.call(heroWrappers, (wrapper, index) => {
        const sliderContainer = wrapper.querySelector('.th_gr_hero-slider')

        if(sliderContainer != undefined) {
          const prevButton = wrapper.querySelector('.th_gr_hero-nav-prev')
          const nextButton = wrapper.querySelector('.th_gr_hero-nav-next')
          const dots = wrapper.querySelectorAll('.th_gr_hero-dot')
          const sliderKey = `hero_${index}`
          
          const heroSlider = new Siema({
            selector: sliderContainer,
            loop: true,
            duration: 500,
            easing: 'ease-out',
            onChange: function() {
              // Update active dot
              if(dots && dots.length) {
                [].forEach.call(dots, (dot, dotIndex) => {
                  if(dotIndex === heroSlider.currentSlide) {
                    dot.classList.add('active')
                  } else {
                    dot.classList.remove('active')
                  }
                })
              }
            }
          })
          
          sliders[sliderKey] = heroSlider

          // Function to equalize slide heights
          const equalizeSlideHeights = () => {
            const slides = sliderContainer.querySelectorAll('.th_gr_hero-slide')
            if(slides && slides.length > 1) {
              let maxHeight = 0
              
              // Reset heights to auto to get natural heights
              for(let i = 0; i < slides.length; i++) {
                slides[i].style.height = 'auto'
              }
              
              // Find the tallest slide
              for(let i = 0; i < slides.length; i++) {
                const slideHeight = slides[i].offsetHeight
                if(slideHeight > maxHeight) {
                  maxHeight = slideHeight
                }
              }
              
              // Set all slides to the tallest height
              if(maxHeight > 0) {
                for(let i = 0; i < slides.length; i++) {
                  slides[i].style.height = maxHeight + 'px'
                }
              }
            }
          }
          
          // Equalize heights after a short delay to ensure images are loaded
          setTimeout(() => {
            equalizeSlideHeights()
          }, 100)
          
          // Re-equalize when images load
          const images = sliderContainer.querySelectorAll('img, video')
          if(images && images.length) {
            let loadedCount = 0
            const totalImages = images.length
            
            const checkAllLoaded = () => {
              loadedCount++
              if(loadedCount === totalImages) {
                setTimeout(() => {
                  equalizeSlideHeights()
                }, 50)
              }
            }
            
            for(let i = 0; i < images.length; i++) {
              if(images[i].complete || images[i].readyState === 4) {
                checkAllLoaded()
              } else {
                images[i].addEventListener('load', checkAllLoaded)
                images[i].addEventListener('error', checkAllLoaded)
              }
            }
          }
          
          // Re-equalize on window resize
          let resizeTimeout
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout)
            resizeTimeout = setTimeout(() => {
              equalizeSlideHeights()
            }, 250)
          })

          if(prevButton) {
            prevButton.addEventListener('click', (e) => {
              e.preventDefault()
              sliders[sliderKey].prev()
            })
          }

          if(nextButton) {
            nextButton.addEventListener('click', (e) => {
              e.preventDefault()
              sliders[sliderKey].next()
            })
          }

          // Handle dot clicks
          if(dots && dots.length) {
            [].forEach.call(dots, (dot, dotIndex) => {
              dot.addEventListener('click', (e) => {
                e.preventDefault()
                sliders[sliderKey].goTo(dotIndex)
              })
            })
          }
        }
      })
    }

    /**
     * Sliders use Siema. See: https://pawelgrzybek.github.io/siema/
     */
    const overflowCarousels = document.querySelectorAll('.overflow_carousel')

    if(overflowCarousels != undefined && overflowCarousels.length) {
      [].forEach.call(overflowCarousels, carousel => {
        const sliderContainer = carousel.querySelector('.s-list')


        if(sliderContainer != undefined) {
          const prevButton = carousel.querySelector('.s-nav-l')
          const nextButton = carousel.querySelector('.s-nav-r')
          sliders.post = new Siema({
            selector: sliderContainer,
            loop: true,
            perPage: {
              480: 1,
              768: 2,
              1024: 3,
            },
          })


          prevButton.addEventListener('click', (e) => {
            e.preventDefault()
            sliders.post.prev()
          })
          nextButton.addEventListener('click', (e) => {
            e.preventDefault()
            sliders.post.next()
          })
        }
      });

      // Watch for sliders to come in view so we can resize them properly
      const resizeCarousel = (observable) => {
        const carousel = _obj.hasValue(observable.target, sliders, 'selector')
        if(carousel !== false) {
          sliders[carousel].resizeHandler()
        }
      }

      const observerOptions  = {
        rootMargin: '0px',
        threshold: 0.1,
      }

      const observer = new IntersectionObserver(resizeCarousel, observerOptions);

      for(let i in sliders) {
        if(sliders[i].hasOwnProperty('selector')) {
          observer.observe(sliders[i].selector);
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js